import React from 'react'
import Main from '../components/FacilitiesPage/Main'

const FacilitiesPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default FacilitiesPage